module.exports = __webpack_public_path__ + "static/media/traffic-lamp.b464c8fe.svg";